import * as React from "react";

const SvgComponent = ({ color, bg, stroke, ...props }) => (
  <svg width={30} height={30} fill={props.bgcolor} {...props}>
    <rect
      x={0.5}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={bg}
      stroke={stroke}
    />
    <path
      d="M21.529 18.656v-1.31h.49a1 1 0 0 0 .982-.98v-2.291a1 1 0 0 0-.982-.982h-.49v-1.309a1 1 0 0 0-.982-.981H7.459c-.529 0-.818.49-.818 1.018v6.798c0 .529.289 1.018.818 1.018h13.088a1 1 0 0 0 .981-.981Zm-13.58 0c-.047 0-.163-.116-.163-.164v-6.38c0-.048.116-.164.164-.164h12.27c.048 0 .163.116.163.164v6.38c0 .048-.115.164-.163.164H7.95Zm.164-6.38v6.053h11.943v-6.014l-11.943-.04Z"
      fill={color}
    />
    <path
      d="M13.76 12.275v2.73l-4.502-1.277 5.968 4.437v-2.73l4.502 1.278-5.968-4.438Z"
      fill={bg}
    />
  </svg>
);

export default SvgComponent;
